/** Audit actions. Stored as text; add new ones as modules ship. */
export const AUDIT_ACTIONS = {
  "auth.sign_in": "Signed in",
  "auth.sign_in_failed": "Failed sign-in",
  "auth.sign_out": "Signed out",
  "auth.session_expired": "Session expired",
  "auth.passkey_added": "Added a passkey",
  "auth.passkey_removed": "Removed a passkey",
  "auth.mfa_enabled": "Set up authenticator app",
  "auth.mfa_email": "Switched to emailed sign-in codes",
  "staff.invited": "Invited staff member",
  "staff.password_reset": "Reset a staff member's password",
  "staff.sign_in_reset": "Reset a staff member's sign-in (passkeys and codes)",
  "staff.updated": "Updated staff member",
  "staff.deactivated": "Deactivated staff member",
  "staff.reactivated": "Reactivated staff member",
  "staff.roles_changed": "Changed staff roles",
  "staff.override_changed": "Changed permission override",
  "staff.w9_requested": "Asked a staff member for a W-9",
  "staff.w9_signed": "Signed a W-9",
  "staff.w9_uploaded": "Uploaded a W-9",
  "staff.w9_viewed": "Opened a W-9",
  "staff.contract_template_saved": "Saved a staff contract template",
  "staff.contract_sent": "Sent a staff contract",
  "staff.contract_signed": "Signed their staff contract",
  "staff.contract_countersigned": "Countersigned a staff contract",
  "staff.contract_cancelled": "Cancelled a staff contract",
  "staff.contract_viewed": "Opened a staff contract",
  "role.created": "Created role",
  "role.updated": "Updated role",
  "role.deleted": "Deleted role",
  "settings.updated": "Updated clinic settings",
  "setup.exported": "Exported the clinic's setup",
  "setup.imported": "Imported a setup file",
  "clinic.updated": "Updated clinic profile",
  "location.created": "Added location",
  "location.updated": "Updated location",
  "catalog.category_created": "Added menu category",
  "catalog.category_updated": "Updated menu category",
  "catalog.categories_reordered": "Reordered menu categories",
  "catalog.category_deleted": "Deleted menu category",
  "catalog.item_created": "Added catalog item",
  "catalog.item_duplicated": "Duplicated catalog item",
  "catalog.item_updated": "Updated catalog item",
  "catalog.item_archived": "Archived catalog item",
  "catalog.item_restored": "Restored catalog item",
  "catalog.imported": "Loaded starter catalog",
  "catalog.print_menu_updated": "Changed the printed menu",
  "recipe.frequencies_imported": "Loaded how often from the menu sheet",
  "payouts.settings_changed": "Changed payout settings",
  "payouts.rate_set": "Set a pay rate",
  "payouts.rate_removed": "Removed a pay rate",
  "payouts.adjusted": "Added a payout bonus or correction",
  "payouts.adjustment_removed": "Removed a payout bonus or correction",
  "payouts.share_set": "Set a revenue share",
  "payouts.share_removed": "Removed a revenue share",
  "payouts.overhead_set": "Set how much overhead comes out before commission",
  "payouts.event_hours_set": "Set who worked an event day (for pay)",
  "payouts.visit_split_set": "Split an event visit's pay by hand",
  "payouts.paid": "Marked a payout paid",
  "payouts.declined": "Marked a payout declined",
  "staff.signature_saved": "Saved a signature for notes",
  "staff.signature_removed": "Removed a saved signature",
  "note.created": "Wrote a school or work note",
  "note.sent": "Sent a school or work note",
  "note.viewed": "Client opened a school or work note",
  "payouts.unpaid": "Undid a payout marked paid",
  "payouts.reopened": "Reopened a paid pay period",
  "plan.created": "Added membership or package",
  "plan.updated": "Updated membership or package",
  "plan.archived": "Archived membership or package",
  "plan.restored": "Restored membership or package",
  "plan.imported": "Loaded starter memberships and packages",
  "client_plan.sold": "Sold a membership or package",
  "client_plan.activated": "Membership or package paid",
  "client_plan.abandoned": "Dropped an unpaid membership or package",
  "client_plan.payment_failed": "Membership payment failed",
  "client_plan.cancelled": "Cancelled a membership",
  "client_plan.cancel_undone": "Took back a membership cancellation",
  "client_plan.ended": "Membership or package ended",
  "client_plan.card_changed": "Changed a membership's card",
  "voucher.restored": "Gave back a voucher",
  "voucher.added": "Added a courtesy voucher",
  "voucher.removed": "Removed an unused voucher",
  "client_plan.transferred": "Brought over a membership (already paid)",
  "client_plan.card_set": "Client added a membership's card by link",
  "formulary.created": "Added formulary item",
  "formulary.updated": "Updated formulary item",
  "formulary.imported": "Loaded starter formulary",
  "inventory.received": "Received inventory",
  "inventory.adjusted": "Adjusted inventory",
  "inventory.lot_updated": "Updated inventory lot",
  "inventory.imported": "Loaded starting inventory",
  "purchase.created": "Recorded purchase",
  "purchase.updated": "Updated purchase",
  "purchase.imported": "Loaded past purchases",
  "supplier.created": "Added supplier",
  "supplier.updated": "Updated supplier",
  "recipe.updated": "Updated recipe",
  "resource.type_created": "Added resource type",
  "resource.type_updated": "Updated resource type",
  "resource.created": "Added resource",
  "resource.updated": "Updated resource",
  "resource.blocked": "Blocked a resource",
  "resource.unblocked": "Removed a resource block",
  "resource.imported": "Loaded starter resources",
  "requirements.updated": "Updated what a service needs",
  "availability.updated": "Updated weekly availability",
  "availability.exception_added": "Added an availability change",
  "availability.exception_removed": "Removed an availability change",
  "availability.hours_added": "Added hours",
  "availability.hours_changed": "Changed hours",
  "availability.hours_removed": "Removed hours",
  "availability.time_off_added": "Added time off",
  "availability.time_off_removed": "Removed time off",
  "location.closed": "Closed the clinic for a day",
  "location.reopened": "Removed a clinic closure",
  "client.viewed": "Viewed client record",
  "client.created": "Added client",
  "client.guardian_attested": "Booker said they're the parent or guardian",
  "client.guardian_checked": "Guardian checked",
  "clients.imported": "Imported clients",
  "past_visits.imported": "Imported past visits from the old system",
  "boulevard.imported": "Imported forms, charts, and notes from Boulevard",
  "boulevard.taken_over": "Took over upcoming Boulevard visits (cutover)",
  "boulevard.merged_id_dropped": "Dropped a Boulevard ID that was merged into another client there",
  "boulevard.id_forgotten": "Forgot a Boulevard ID that couldn't be read",
  "boulevard.id_replaced": "Replaced a Boulevard ID that couldn't be read with the working one",
  "imported_record.viewed": "Opened a form or chart from Boulevard",
  "client.updated": "Updated client",
  "client.archived": "Archived client",
  "client.restored": "Restored client",
  "client.merged": "Merged client records",
  "client.note_added": "Added client note",
  "client.tags_changed": "Changed client tags",
  "client.consent_changed": "Changed client consent",
  "client.link_added": "Linked clients",
  "client.link_removed": "Unlinked clients",
  "tag.created": "Added tag",
  "tag.updated": "Updated tag",
  "tag.imported": "Loaded starter tags",
  "booking.created": "Booked",
  "boulevard.connected": "Connected Boulevard (read-only)",
  "boulevard.disconnected": "Disconnected Boulevard",
  "boulevard.turned_off": "Turned Boulevard off (left Boulevard)",
  "boulevard.turned_on": "Turned Boulevard back on",
  "boulevard.signed_in": "Signed in to Boulevard",
  "boulevard.mapped": "Matched a Boulevard staff member, service, or location",
  "boulevard.flag_settled": "Settled a Boulevard sync flag",
  "boulevard.synced": "Synced from Boulevard",
  "form.signed": "Signed a form",
  "form.voided": "Voided a signed form",
  "call.played": "Listened to a voicemail",
  "device.added": "Added a clinic iPad",
  "device.paired": "Paired a clinic iPad",
  "device.unlinked": "Unlinked a clinic iPad",
  "device.forms_sent": "Sent forms to a clinic iPad",
  "device.check_in": "Checked in on a clinic iPad",
  "device.checkout_sent": "Sent a checkout to a clinic iPad",
  "device.place_set": "Set where a clinic iPad is used",
  "device.walk_ins_set": "Turned walk-ins on or off for a clinic iPad",
  "device.lobby_set": "Turned the lobby display on or off for a device",
  "device.link_made": "Made a one-time pairing link for a device",
  "device.screenings_set": "Turned telehealth screenings on or off for a clinic iPad",
  "call.handled": "Marked a voicemail or missed call handled",
  "call.unread": "Marked a voicemail or missed call unread",
  "call.linked": "Linked a voicemail or missed call to a client",
  "conversation.done": "Marked a client's texts answered",
  "conversation.linked": "Linked texts from an unknown number to a client",
  "conversation.unlinked": "Unlinked a number's texts and calls from a client",
  "client.phone_added": "Added one of a client's other numbers",
  "number.saved": "Saved a number as not a client",
  "number.blocked": "Blocked a number",
  "number.updated": "Changed a saved number",
  "number.removed": "Removed a saved number",
  "client.phone_removed": "Removed one of a client's other numbers",
  "form.viewed": "Viewed a signed form",
  "form.updated": "Changed form wording",
  "forms.overridden": "Started a visit without signed forms",
  "forms.link_sent": "Texted the forms link",
  "chart.created": "Started a chart",
  "chart.viewed": "Viewed a chart",
  "chart.saved": "Saved a chart draft",
  "chart.ingredient_left_out": "Left a medication out of a visit",
  "chart.ingredient_put_back": "Put a left-out medication back",
  "chart.signed": "Signed a chart",
  "chart.addendum": "Added a chart addendum",
  "chart.update_started": "Started updating a signed chart",
  "chart.update_discarded": "Discarded an unsigned chart update",
  "chart.reviewed": "Reviewed a chart (medical director)",
  "chart.ai_cleanup": "Used AI Cleanup on a chart's narrative",
  "mobile.accepted": "Accepted mobile request",
  "mobile.declined": "Declined mobile request",
  "mobile.expired": "Mobile request cancelled (no answer)",
  "event.created": "Created event",
  "event.updated": "Changed event",
  "event.dates_changed": "Changed event dates or staffing",
  "appointment.moved": "Moved appointment",
  "appointment.go_ahead": "Treating without forms or a current GFE (reason)",
  "appointment.updated": "Changed appointment",
  "appointment.status_changed": "Changed appointment status",
  "card.saved": "Saved a card on file",
  "card.not_saved": "A card wasn't saved",
  "card.link_sent": "Sent a link to add a card",
  "desk_phone.lookup": "Showed a caller on the desk phone",
  "event_page.recognized": "Recognized a client on an event page (name and birthday)",
  "desk_phone.changed": "Changed a desk phone",
  "availability.changed": "Availability light changed",
  "availability_hook.created": "Availability light link made",
  "availability_hook.revoked": "Availability light link turned off",
  "availability_hook.door_set": "Set a link as the door's opened / closed alarm",
  "staff.alerts_changed": "Changed staff alerts (text / email)",
  "staff.calendar_changed": "Changed Google Calendar sync",
  "staff.calendar_link_made": "Made a calendar subscribe link",
  "staff.calendar_link_off": "Turned off a calendar subscribe link",
  "staff.view_as_started": "Started viewing the app as a staff member (read-only)",
  "staff.view_as_ended": "Stopped viewing the app as a staff member",
  "availability.left_for_day": "Blocked off the rest of the day (door closed)",
  "card.removed": "Removed a card on file",
  "deposit.held": "Held a deposit",
  "deposit.captured": "Charged a held deposit",
  "deposit.released": "Released a deposit hold",
  "deposit.paid": "Paid a deposit",
  "fee.charged": "Charged a no-show or late-cancel fee",
  "fee.failed": "No-show or late-cancel fee couldn't be charged",
  "fee.waived": "Waived a fee that was owed",
  "fee.billed": "Added a fee that was owed to a bill",
  "bill.changed": "Changed a bill",
  "payment.received": "Received a payment",
  "payment.canceled": "Cancelled a card reader payment (paid another way)",
  "payment.refunded": "Refunded a payment",
  "credit.added": "Added account credit for a client",
  "credit.removed": "Took account credit off a client's account",
  "contacts.released": "Stopped keeping RingCentral contacts, leaving them in RingCentral",
  "payment.link_sent": "Sent a pay link",
  "message.template_updated": "Changed message wording",
  "message.sent_by_staff": "Sent a client message",
  "gfe.queued": "Set up a good faith exam (goes out after the intake)",
  "gfe.sent": "Sent a good faith exam",
  "gfe.answers_failed": "Couldn't pre-fill a good faith exam from the intake",
  "gfe.send_failed": "Couldn't send a good faith exam",
  "gfe.resent": "Resent a good faith exam link",
  "gfe.cancelled": "Cancelled a good faith exam",
  "gfe.result": "Good faith exam result received",
  "gfe.flagged": "Flagged a good faith exam's restrictions",
  "gfe.cleared": "Cleared a good faith exam's notes",
  "gfe.overridden": "Started a visit without a current good faith exam",
  "gfe.auto_send_paused": "Paused good faith exam auto-send",
  "gfe.auto_send_resumed": "Resumed good faith exam auto-send",
  "client.signin_code_sent": "Sent client sign-in code",
  "client.signed_in": "Client signed in to book",
} as const;

export type AuditAction = keyof typeof AUDIT_ACTIONS;
